<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\ja\newManual\myCourseManual-1.png" alt="" /></div>
                <div>
                    <p>① メインツールバーの「マイコース」アイコンをクリックすると、受講者の受講対象とする全コースを纏めて表示する「マイコース」画面に遷移します。</p>
                    <p>② カテゴリをクリックすると、該当カテゴリに属するコースのみ表示されます。</p>
                    <p>③ 「設定」ボタンをクリックしたら、カテゴリを表示するかどうかを設定することがきます。</p>
                    <p>※ データテーブルに表示されているコースには、完了したコース（つまり、[Close Request]を完了して送信したコース）は含まれていません。</p>
                    <p>&nbsp;「修了コースを含む」スイッチコントロールにて終了したコースが表示されるかどうか制御することができます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\myCourseManual-2.png" alt="" /></div>
                <div>
                    <p>各スイッチコントロール、又は「すべて選択」、「すべて選択を解除」ボタンにてカテゴリの表示・非表示設定を行い、「保存」ボタンを押下することでカテゴリの表示・非表示状態を更新します。</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/myCourse_manual.vue